"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pesaro": {
    "3fd6f9db": [{
      "hkey": "a9e79d82",
      "slug": "cattabrighe-vismara",
      "name": "Cattabrighe-Vismara",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "64cfc05b",
      "slug": "celletta",
      "name": "Celletta",
      "primary": false,
      "skipSearch": false
    }],
    "cattabrighe-celletta": [{
      "hkey": "a9e79d82",
      "slug": "cattabrighe-vismara",
      "name": "Cattabrighe-Vismara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pesaro"
    }],
    "de6222a4": [{
      "hkey": "bb0f3b04",
      "slug": "loreto-montegranaro",
      "name": "Loreto-Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "bb0f3b04",
      "slug": "loreto-montegranaro",
      "name": "Loreto-Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d7ea1904": [{
      "hkey": "bb0f3b04",
      "slug": "loreto-montegranaro",
      "name": "Loreto-Montegranaro",
      "primary": true,
      "skipSearch": false
    }],
    "montegranaro": [{
      "hkey": "bb0f3b04",
      "slug": "loreto-montegranaro",
      "name": "Loreto-Montegranaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pesaro"
    }],
    "3c726153": [{
      "hkey": "2856b8c9",
      "slug": "porto-soria",
      "name": "Porto-Soria",
      "primary": true,
      "skipSearch": false
    }],
    "soria": [{
      "hkey": "2856b8c9",
      "slug": "porto-soria",
      "name": "Porto-Soria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aab1975e": [{
      "hkey": "a9e79d82",
      "slug": "cattabrighe-vismara",
      "name": "Cattabrighe-Vismara",
      "primary": true,
      "skipSearch": false
    }],
    "vismara": [{
      "hkey": "a9e79d82",
      "slug": "cattabrighe-vismara",
      "name": "Cattabrighe-Vismara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pesaro"
    }]
  }
};
exports["default"] = _default;